module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/widgets/edit-widget-modal/edit-widget-modal.component.scss
// module id = ./src/app/widgets/edit-widget-modal/edit-widget-modal.component.scss
// module chunks = main